/**
 * Ao digitar no campo município, refaz a busca com q= (aceita sem acento: julio = júlio).
 * Requer obs_load_cities e observer(stateField). stateField = 'billing_address_state' ou 'delivery_address_state'.
 */
import { loadOptions } from '../../versa/formset.js';
import { fetchCities } from './obs_load_cities.js';

let debounceTimer = null;
const DEBOUNCE_MS = 200;

export default function (stateField) {
	return {
		_source: stateField,
		events: ['input'],
		handleEvents(ev) {
			if (ev.type !== 'input') return;
			const node = document.querySelector(this.selector);
			if (!node?.form) return;
			const stateEl = node.form.querySelector(`#${stateField}`);
			const uf = stateEl?.value ? String(stateEl.value).trim().toUpperCase().slice(0, 2) : '';
			const q = (node.value || '').trim();
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(async () => {
				const data = await fetchCities(uf, q);
				loadOptions(this.selector, data, 'id', ['city']);
				// Não chamar refresh() quando o valor atual já é um city_id (7 dígitos): evita apagar a seleção que o usuário acabou de fazer
				const currentVal = (node.value || '').trim();
				if (!/^\d{7}$/.test(currentVal))
					this.refresh?.();
			}, DEBOUNCE_MS);
		}
	};
}
